import { VsRadioData } from './components/radio/vs-radio.model';

export interface Field {
  type: string;
  name: string;
  label: string;
  tooltip: string;
  value: string;
  placeholder: string;
  singleColumn: string;
  rules: Rule[];
  data: VsRadioData[];
  accepts: string;
  gmapRef: string;
  successUploadMessage: string;
  uploadErrorMessage: string;
  uploadingMessage: string;
  fileFormatErrorMessage: string;
  fileSizeErrorMessage: string;
  requiredText: string;
  isInline: boolean;
  aboveInputContent: string;
  belowInputContent: string;
  betweenInputContent: string;
  renderIf: Condition;
  inputPrefix: any[];
}

export interface Condition {
  key: string;
  value: string;
}

export interface Rule {
  required: string;
  regex: string;
  notBefore: string;
  notAfter: string;
  email: string;
  max: string;
  min: string;
  numeric: string;
  alpha: string;
  alpha_num: string;
  decimal: string;
  include: string;
  fileExt: string;
  fileSize: string;
  isWeekend: string;
  isWeekday: string;
  allRequired: string;
  oneRequired: string;
}

export const VALIDATION_ATTRIBUTES = {
  REQUIRE: 'required',
  REQUIRE_IF:'requireIf',
  NUMERIC: 'numeric',
  NUMBER: 'number',
  ALPHA: 'alpha',
  ALPHA_NUMERIC: 'alpha_num',
  EMAIL: 'email',
  DECIMAL: 'decimal',
  MAX: 'max',
  MIN: 'min',
  MAX_VALUE: 'maxValue',
  MIN_VALUE: 'minValue',
  REGEX: 'regex',
  DATE_FORMAT: 'dateFormat',
  NOT_BEFORE: 'notBefore',
  NOT_AFTER: 'notAfter',
  URL: 'url',
  WEEKEND: 'isWeekend',
  WEEKDAY: 'isWeekday',
  CARD: 'cardCheck',
  FILE_TYPE: 'filetype',
  FILE_SIZE: 'filesize',
  ALL_REQUIRED: 'allRequired',
  ONE_REQUIRED: 'oneRequired',
  CONFIRM: 'confirm',
  DATE_BETWEEN: 'dateBetween',
  NOT_WEEKEND: 'notWeekend',
};

